<template>
  <div class="container">
    <h2>填写说明</h2>
    <div class="docs">
      <p class="line">1、本人在填写本入职申请表时，已保证自己符合国家法定的劳动年龄的标准，且与其他任何用人单位、机构、组织、团体无劳动关系；若违反前述承诺，导致用人单位被行政、诉讼或仲裁追究有关经济责任的，所有责任均由本人承担。</p>
      <p class="line">
        2、本人如有传染病、精神病或其他可能影响在用人单位工作的病史，本人应以书面形式向用人单位说明。
      </p>
      <p class="line">
        3、如本人与其他公司签订仍然生效的保密协议、竞业限制协议的，应以书面形式向公司说明情况。
      </p>
      <p class="line">4、本人填写的本人入职申请表所有信息真实有效，并授权用人单位（或用人单位授权其他机构）对本人填写内容进行核实。如有任何虚假，用人单位可按严重违反用人单位规章制度解除劳动合同，同时追究因此引起的所有责任。</p>
      <p class="line">5、本人入职后不得将与聘用有关的相关信息（包括但不限于工资）未经用人单位许可向第三方透露。本人在职期间或离职后，用人单位可以依法将本人在本单位的工作状况对外公布或向有需要的第三方提供。</p>
      <p class="line">6、本人一旦被本用人单位录用，入职时应出示真实有效的离职证明书，或与本公司签订离职证明协议，否则本人承担由此给本用人单位带来的损失及向第三方的赔偿损失。</p>
      <p class="line">7、本入职申请表中的信息有变化，本人应以及时向公司人事部门提交最新信息。</p>
      <p class="line">8、如被本公司录用，本人有责任领取公司发放的员工手册或其他手册，并依法在一个月内与公司签订劳动合同，本人将认真阅读并遵守员工手册及各项规章制度。</p>
      <p class="line">
        9、本人清楚公司可以根据实际情况更新员工手册、规章制度与劳动纪律，本人将随时关注公司网站、相关平台、宣传栏（包括但不限于）等各种公示方式公示的规章制度与劳动纪律并予以严格遵守。
      </p>
      <p class="line">
        10、入职时如有任何兼职行为（包括但不限于直销），应以书面形式向公司说明情况，未经公司书面同意，入职后不得从事任何形式的兼职行为。
      </p>
      <p class="line">
        11、曾被追究刑事责任的，应在入职时以书面形式向公司说明情况。
      </p>
      <p class="line" style="text-indent: 2em;">本人充分了解上述资料的真实性是双方订立劳动合同的前提条件，本人填写的以上任何信息虚假或没有履行以上特殊说明的义务，无论任何时候被发现，本人均同意被公司视为严重违反《劳动合同法》的诚实信用原则以及用人单位的规章制度，公司可以即时解除劳动合同且不用支付经济补偿金。</p>
    </div>
  </div>
</template>
<style scoped>
.docs {
    font-size: 0.8rem;
    padding: 1.2em;
    text-align:left;
    color:rgb(90, 90, 90);
    height:60vh;
    overflow: scroll;
}
.docs .line{
    padding:0;
    margin:5px
}
</style>
<script>

</script>